import React from "react";
import "./textoMain.css";

const Header = () => {
  return (
    <div className="container-textMain-Mobile">
      <h1 id="texto-main-Mobile">
        Sistema de Automação Predial
      </h1>
    </div>
  );
};

export default Header;
